/**
 * Recursively goes through all subframes of the current base and posts the message to them.
 * If the maximum level is not reached yet, invokes the same for the subframes,
 * so they can post the message to their children
 * @param {*} base The base object for the current level (e.g. window)
 * @param {*} level Starting level, increased with every recursive call
 * @param {*} maxLevel Maximum level for recursive call (max subframe depth)
 * @param {*} frontendEvent Event to broadcast
 */
function broadcastToSubLevels(base, level, maxLevel, frontendEvent) {
    for (let i = 0; i < base.frames.length; i++) {
        if (level <= maxLevel) {
            broadcastToSubLevels(base.frames[i], level + 1, maxLevel, frontendEvent);
        }
        if (frontendEvent.targetFrameName && base.frames[i].name !== frontendEvent.targetFrameName)
            continue;
        base.frames[i].postMessage(frontendEvent, "*");
    }
}
export var EventType;
(function (EventType) {
    EventType["ContentLoad"] = "CONTENT_LOAD";
    EventType["TabSwitch"] = "TAB_SWITCH";
    EventType["WebEvent"] = "WEB_EVENT";
    EventType["ClickEvent"] = "CLICK_EVENT";
    EventType["ModalClosed"] = "MODAL_CLOSED";
    EventType["DashboardInteraction"] = "DASHBOARD_INTERACTION";
})(EventType || (EventType = {}));
/**
 * Class for sending frontend events. Frontend events are messages sent across iframes within the application.
 */
export class FrontendEvents {
    contentLoad() {
        this.broadcast({ type: EventType.ContentLoad });
    }
    tabSwitch(oldTabKey, newTabKey) {
        this.broadcast({ type: EventType.TabSwitch, oldTabKey, newTabKey });
    }
    webEvent(eventObj, sourceIframeName) {
        this.broadcast({ type: EventType.WebEvent, event: eventObj, sourceIframeName });
    }
    click(sourceIframeName) {
        this.broadcast({ type: EventType.ClickEvent, sourceName: sourceIframeName });
    }
    modalClosed() {
        this.broadcast({ type: EventType.ModalClosed });
    }
    broadcast(typeOrEvent, data, frameName) {
        if (typeof typeOrEvent === 'string') {
            // please note that the call below is not typechecked as the data parameter is not typed
            this.broadcast({ ...data, type: typeOrEvent, targetFrameName: frameName });
        }
        else {
            // Broadcast to subframes (recursive)
            broadcastToSubLevels(window, 0, 3, typeOrEvent);
            // broadcast to top (this) window
            if (!typeOrEvent.targetFrameName || typeOrEvent.targetFrameName === "top")
                window.postMessage(typeOrEvent, "*");
            // Publish web events to parent (e.g. when opened in SSO)
            if (typeOrEvent.type === EventType.WebEvent && !typeOrEvent.targetFrameName && window.parent !== window.self) {
                window.parent.postMessage(typeOrEvent, "*");
            }
        }
    }
}
// Handling events example:
/*
window.addEventListener('message', function (message: MessageEvent<MessageDataType>) {
 if (message.data.type === 'TAB_SWITCH')
   console.debug('tab switched', message.data.newTabKey, message.data.oldTabKey);
})
*/
export default new FrontendEvents();
